/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hostname: NonNullable<unknown> }} Disabled_Websites_Already_Enabled_Limited_Managed_InInputs */

const en_disabled_websites_already_enabled_limited_managed_in = /** @type {(inputs: Disabled_Websites_Already_Enabled_Limited_Managed_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} is already enabled with limited compatibility. You can manage it in the "Websites with Limited Compatibility" section.`)
};

const es_disabled_websites_already_enabled_limited_managed_in = /** @type {(inputs: Disabled_Websites_Already_Enabled_Limited_Managed_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hostname} ya está habilitado con compatibilidad limitada. Puedes administrarlo en la sección "Sitios con compatibilidad limitada".`)
};

/**
* | output |
* | --- |
* | "{hostname} is already enabled with limited compatibility. You can manage it in the \"Websites with Limited Compatibility\" section." |
*
* @param {Disabled_Websites_Already_Enabled_Limited_Managed_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_already_enabled_limited_managed_in = /** @type {((inputs: Disabled_Websites_Already_Enabled_Limited_Managed_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Already_Enabled_Limited_Managed_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_already_enabled_limited_managed_in(inputs)
	return en_disabled_websites_already_enabled_limited_managed_in(inputs)
});